export const SCREEN_OVERLAY = 'six15_overlay';
export const SCREEN_SHOT = 'six15_screenshot';
